import React, { useState, useEffect } from 'react';
import PortfolioStore from '../store/portfolioStore';
import Nav from '../components/site/Nav';
import Hero from '../components/site/Hero';
import PortfolioGrid, { AppDetail } from '../components/site/PortfolioGrid';
import StudioBlock from '../components/site/StudioBlock';
import ContactBlock from '../components/site/ContactBlock';
import SiteFooter from '../components/site/SiteFooter';

export default function LandingPage() {
  const [route, setRoute] = useState({ page: 'home' });
  const [apps, setApps] = useState(() => PortfolioStore.getAll());

  useEffect(() => {
    return PortfolioStore.subscribe(setApps);
  }, []);

  const navigate = (page, payload) => {
    if (page === 'app') setRoute({ page: 'app', appId: payload });
    else setRoute({ page });
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  const currentApp = route.page === 'app' ? apps.find((a) => a.id === route.appId) : null;

  return (
    <div>
      <Nav active={route.page} onNavigate={navigate} />
      {route.page === 'home' && (
        <>
          <Hero onNavigate={navigate} />
          <PortfolioGrid apps={apps} onOpen={(id) => navigate('app', id)} />
          <StudioBlock apps={apps} />
          <ContactBlock />
        </>
      )}
      {route.page === 'app' && (
        <AppDetail app={currentApp} onBack={() => navigate('home')} />
      )}
      {route.page === 'studio' && <StudioBlock apps={apps} />}
      {route.page === 'contact' && <ContactBlock />}
      {route.page === 'journal' && (
        <section style={{ padding: '120px 32px', maxWidth: 720, margin: '0 auto', textAlign: 'center' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'var(--fg-muted)', marginBottom: 24 }}>Journal</div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 64, margin: 0, lineHeight: 1 }}>Coming soon.</h2>
          <p style={{ color: 'var(--fg-muted)', marginTop: 16 }}>We're writing one. It'll be here in a few weeks.</p>
        </section>
      )}
      <SiteFooter />
    </div>
  );
}
